import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Nullish, StatusLabel } from '@shared/utils';
import { TagModule } from '@openng/optimus-ui/tag';
import { TooltipModule } from '@openng/optimus-ui/tooltip';

@Component({
  selector: 'ui-status-indicator',
  host: { class: 'inline-block' },
  templateUrl: './status-indicator.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TagModule, TooltipModule],
})
export class StatusIndicatorComponent {
  readonly statusLabels = input<Record<string, StatusLabel> | Nullish>(null);

  readonly status = input<string | Nullish | number>(null);

  readonly onlyIcon = input(false);

  readonly label = input(false);

  get activeStatus() {
    const statusLabels = this.statusLabels();
    const status = this.status();
    return statusLabels && status ? statusLabels[status] : null;
  }

  get tooltip(): string {
    return this.onlyIcon() && this.activeStatus?.label ? this.activeStatus.label : (null as unknown as string);
  }
}
